<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm"></app-dati-generali-fascicolo-common>
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" /> 
  <div class="row">
    <div datePickerInput class="col-sm-6" [labelInput]="'Data richiesta'" formControlName="dataRichiesta"
      [dataAl]="request.fascicolo.dataEmissione" [control]="datiGeneraliForm.controls['dataRichiesta']"
      [(ngModel)]="request.fascicolo.dataInizioFascicolo" [mandatory]="true"></div>
    <div datePickerInput class="col-sm-6" [labelInput]="'Data emissione'" formControlName="dataEmissione"
      [dataDal]="request.fascicolo.dataInizioFascicolo" [(ngModel)]="request.fascicolo.dataEmissione"></div>
  </div>

  <div class="row">
    <div class="col-sm-3">
      <p class="active singlecheckbox radiobutton dati_generali">
        <label class="fakelabel">Tipo richiedente<span class="mandatory radiobutton">*</span></label>
        <input name="tipoRichiedente" formControlName="tipoRichiedente" id="ricInterno"
          (ngModelChange)="tipoRichiedenteChanged()" type="radio" value="interno" [(ngModel)]="checkedTipoRichiedente">
        <label for="ricInterno">Interno</label>
        <input name="tipoRichiedente" formControlName="tipoRichiedente" id="ricEsterno"
          (ngModelChange)="tipoRichiedenteChanged()" type="radio" value="esterno" [(ngModel)]="checkedTipoRichiedente">
        <label for="ricEsterno">Esterno</label>
      </p>
    </div>

    <div comboModInput class="col-sm-5" [labelOption]="'nome'" [labelInput]="'Richiedente Interno'"
      formControlName="richiedenteInterno" [objectReference]="request.fascicolo.richiedenteInterno"
      (onReturn)="request.fascicolo.richiedenteInterno = $event" [optionsCombo]="soggettiOptions"
      [mandatory]="request.fascicolo.tipoRichiedente" [submitPending]="checkedTipoRichiedente != 'interno'"></div>

    <div textInput class="col-sm-4" [labelInput]="'Richiedente Esterno'" formControlName="richiedenteEsterno"
      [mandatory]="!request.fascicolo.tipoRichiedente" [(ngModel)]="request.fascicolo.richiedenteEsterno"
      [submitPending]="checkedTipoRichiedente != 'esterno'"></div>

  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Quesito/richiesta'"
      formControlName="richiesta" [(ngModel)]="request.fascicolo.richiesta" [mandatory]="true"></div>
  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Sintesi parere'"
      formControlName="sintesiParere" [(ngModel)]="request.fascicolo.sintesiParere"></div>
  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Note'" formControlName="note"
      [(ngModel)]="request.fascicolo.note"></div>
  </div>
  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]=" (checkedTipoRichiedente === 'interno' && !request.fascicolo.richiedenteInterno) ||
														(checkedTipoRichiedente === 'esterno' && !request.fascicolo.richiedenteEsterno) ||
														!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
